import * as XLSX from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import { FollowModelExcelExportStepTwo } from './step-two/FollowOnModelTemplateStepTwo';
import { CommitmentAllocationModelExcelExport } from 'src/app/domain/follow-on/component/commitment-allocation-model-table/commitment-allocation-model-table.component';
import { FollowOnModelTableTemplateStepThree } from './FollowOnModelTabletemplate';
import { CommitmentAllocationTemplate } from '../commitment-allocation/commitment-allocation.template';
import { WorkSheet } from "xlsx-js-style";

export class FollowOnTableAllStepsTemplate implements ExcelTemplate {

  export(data: CommitmentAllocationModelExcelExport): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheetStepTwo = this.getSheetStepTwo(data);
    const sheetStepThree = this.getSheetStepThree(data);
    const sheetStepOnePredict = this.getSheetStepOneGrowthPrediction(data);
    XLSX.utils.book_append_sheet(book, sheetStepOnePredict, 'Growth prediction');
    XLSX.utils.book_append_sheet(book, sheetStepTwo, 'Investment allocation');
    XLSX.utils.book_append_sheet(book, sheetStepThree, 'Performance prediction');
    return book;
  }

  getSheetStepOneGrowthPrediction(data): WorkSheet {
    return new CommitmentAllocationTemplate().getSheet(data, 'growthPrediction');
  }

  getSheetStepTwo(data: CommitmentAllocationModelExcelExport): WorkSheet {
    return new FollowModelExcelExportStepTwo().getSheetStep2(data);
  }

  getSheetStepThree(data: CommitmentAllocationModelExcelExport): WorkSheet {
    return new FollowOnModelTableTemplateStepThree().getSheetStepThree(data);
  }
}
